import { render, staticRenderFns } from "./spTableColumn.vue?vue&type=template&id=3fe266e7&"
import script from "./spTableColumn.vue?vue&type=script&lang=js&"
export * from "./spTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports